import React, { useState, useEffect } from "react";
import { Alert, AlertHeading, Button, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";

import * as turf from "@turf/turf";


import { api } from "./pureFunctions"
import Karte from "./Karte";
import { getStaticData, parseOODate } from "./pureFunctions";
import { getAppointmentsWithLocations } from "./networkFunctions";
import { daysFactor, header, host } from "./globalVariables";
import FototerminErstellung from "./FototerminErstellung";
import { transform } from "lodash";
import { useConfig } from "./ConfigContext";

const suedPolygon = [
   [48, 12],
   [47.75711831155178, 9.600181216236495],
   [49, 7],
   [47, 7],
   [47, 12],
   [48, 12],
];

const zustandigkeit = {
   Süden: { id: "251", location: [9.63688645669658, 47.807287614579764] },
   Norden: { id: /* "187" */ "247", location: [9.788105986430667, 48.099821309647695] },
};

let weatherColors = { Clear: "#fff9", Clouds: " #acf9", Snow: "#9999", Rain: "#6698" };
// let weatherColors = { Clear: "linear-gradient(45deg, #0000, #fff)", Clouds:"linear-gradient(45deg, #0000, #acf, #0000)", Snow:"radial-gradient( #0000, #9999)", Rain:"linear-gradient(45deg, #0000, #6698)"  };
const calenderInterval = ["-", 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
const initTerminData = {
   fotos: "Ja",
   luftaufnahmen: "Ja",
   matterport: "Nein",
   ogulo: "Nein",
   wohnflaeche: "",
   grundstuecksflaeche: "",
   objektart: "",
   anzahl_zimmer: "",
   datum_von: new Date(),
   datum_bis: new Date(new Date().getTime() + daysFactor * 7),
   duration: 0,
   flexibel: "Nein",
   ordnungszustand: "",
   zusatzinfos: "",
   starttime: "",
   endtime: "",
   fotograf: "",
   benutzer: "",
};

const pufferZeit = 15;
const startHour = [8, 15];
const endHour = [16, 0];

export default function FotoTerminierung({  }) {
   const config=useConfig()
   const [terminData, setTerminData] = useState(initTerminData);
   const [objData, setObjData] = useState({});
   const [area, setArea] = useState();
   const [selectedTermin, setSelectedTermin] = useState();
   const [basicDataTermine, setBasicDataTermine] = useState();
   const [fullDataTermine, setFullDataTermine] = useState();
   const [terminObjects, setTerminObjects] = useState();
   const [availableUsers, setAvailableUsers] = useState();
   const [availableDays, setAvailableDays] = useState([]);
   const [timeSlots, setTimeSlots] = useState();
   const [selectedTimeSlot, setSelectedTimeSlot] = useState();
   const [progress, setProgress] = useState();
   const [ownerId, setOwnerId] = useState();
   const [weatherData, setWeatherData] = useState();

   const [userObjects, setUserObjects] = useState();

   async function getBasicData() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();
      setUserObjects(cleanUserData.userObject);
   }

   useEffect(() => {
      let params = new URLSearchParams(document.location.search);
      const url_id = params.get("estateid");
      const url_ownerID = params.get("ownerid");
      if (url_id) {
         getData(url_id);
         setOwnerId(url_ownerID);
         getBasicData();
      }
   }, []);

   function changeTerminData(key, value, initialData) {
      let newTerminData = structuredClone(initialData ? initialData : terminData);
      if (value) {
         newTerminData[key] = value;
      }
      let newDuration = 0;
      if (newTerminData.fotos === "Ja") {
         newDuration += 0.3 * newTerminData.wohnflaeche + newTerminData.anzahl_zimmer * 1;
      }

      if (newTerminData.luftaufnahmen === "Ja") {
         newDuration += 15;
      }
      if (newTerminData.ogulo === "Ja") {
         newDuration += 20;
      }
      if (newTerminData.ordnungszustand === "Sehr viel zum Aufräumen") {
         newDuration += newTerminData.wohnflaeche * 0.3;
      }
      if (newTerminData.ordnungszustand === "Normal (es muss ein wenig aufgeräumt werden)") {
         newDuration += newTerminData.wohnflaeche * 0.1;
      }

      if (newTerminData.objektart !== "wohnung") {
         newDuration += newTerminData.wohnflaeche * 0.1;
      }
      if (newTerminData.matterport === "Ja") {
         newDuration += newTerminData.wohnflaeche * 0.7 + newTerminData.anzahl_zimmer * 1;
      }

      newTerminData.duration = Math.ceil(newDuration * 0.2) * 5;

      setTerminData(newTerminData);
   }

   async function getRoute(myTimeSlotIte) {
      let reqdata = {
         transportMode: "car",
         origin: myTimeSlotIte.terminOrtBefore[1] + "," + myTimeSlotIte.terminOrtBefore[0],
         via: objData.breitengrad + "," + objData.laengengrad,
         destination: myTimeSlotIte.terminOrtAfter[1] + "," + myTimeSlotIte.terminOrtAfter[0],
      };

      await api.post( "/api/getHereRoute", reqdata, header).then((response) => {
         console.log(response);
         let routeResponse = response.data.routes ? response.data.routes[0].sections : false;
         console.log(routeResponse);
         if (routeResponse) {
            myTimeSlotIte.distanceBefore =
               pufferZeit +
               Math.ceil(
                  0.2 * ((new Date(routeResponse[0].arrival.time) - new Date(routeResponse[0].departure.time)) / 60000),
               ) *
                  5;
            myTimeSlotIte.distanceAfter =
               pufferZeit +
               Math.ceil(
                  0.2 * ((new Date(routeResponse[1].arrival.time) - new Date(routeResponse[1].departure.time)) / 60000),
               ) *
                  5;
         }
      });

      setTerminData((prev) => ({
         ...prev,
         starttime: new Date(myTimeSlotIte.start.getTime() + myTimeSlotIte.distanceBefore * 60000),
         endtime: new Date(myTimeSlotIte.start.getTime() + (myTimeSlotIte.distanceBefore + prev.duration) * 60000),
      }));
      setSelectedTimeSlot(myTimeSlotIte);
   }

   async function getWeather(coords) {
      let newWeatherdata = await api.post("/api/getWeather", coords, header)
         .then((response) => {
            console.log(response);

            if (response.data && response.data.list) {
               return response.data.list.reduce(
                  (oldObj, item) => ({
                     ...oldObj,
                     [new Date(item.dt * 1000).toDateString()]: oldObj[new Date(item.dt * 1000).toDateString()]
                        ? [...oldObj[new Date(item.dt * 1000).toDateString()], item]
                        : [item],
                  }),
                  {},
               );
            }
         })
         .catch((err) => {
            console.log(err);
            return false;
         });

      console.log(newWeatherdata);
      setWeatherData(newWeatherdata);
   }

   async function getData(url_id) {
      let estateBasicData = await api.post("/api/getEstateBasicData",
            [
               {
                  id: url_id,
                  datarequest: [
                     "objektnr_extern",
                     "grundstuecksflaeche",
                     "wohnflaeche",
                     "objektart",
                     "anzahl_zimmer",
                     "benutzer",
                     "breitengrad",
                     "laengengrad",
                     "ind_3374_Feld_ObjIndividualCategoryFields314", //ordnungszustand
                     config.estate.objektBezeichnung,
                  ],
               },
            ],
            header,
         )
         .catch((err) => {
            console.log(err);
         });

      console.log(estateBasicData.data);

      setObjData({ ...estateBasicData.data, id: url_id });

      let turfPoly = turf.polygon([suedPolygon.map((item) => [item[1], item[0]])], { name: "sudPoly" });
      let point = turf.point([
         parseFloat(estateBasicData.data.laengengrad),
         parseFloat(estateBasicData.data.breitengrad),
      ]);

      getWeather({ lon: estateBasicData.data.laengengrad, lat: estateBasicData.data.breitengrad });

      const isSudBereich = turf.booleanContains(turfPoly, point);

      setArea(isSudBereich ? "Süden" : "Norden");

      changeTerminData(false, false, {
         ...terminData,
         benutzer: estateBasicData.data.benutzer,
         fotograf: zustandigkeit[isSudBereich ? "Süden" : "Norden"].id,
         grundstuecksflaeche: estateBasicData.data.grundstuecksflaeche,
         wohnflaeche: estateBasicData.data.wohnflaeche,
         anzahl_zimmer: estateBasicData.data.anzahl_zimmer,
         objektart: estateBasicData.data.objektart,
         ordnungszustand: estateBasicData.data.ind_3374_Feld_ObjIndividualCategoryFields314,
      });

      /* setTerminData((prev) => ({
         ...prev,
         benutzer: estateBasicData.data.benutzer,
         fotograf: zustandigkeit[isSudBereich ? "Süden" : "Norden"].id,
         grundstuecksflaeche: estateBasicData.data.grundstuecksflaeche,
         wohnflaeche: estateBasicData.data.wohnflaeche,
         anzahl_zimmer: estateBasicData.data.anzahl_zimmer,
         objektart: estateBasicData.data.objektart,
         ordnungszustand: estateBasicData.data.ind_3374_Feld_ObjIndividualCategoryFields314,
      })); */

      console.log(isSudBereich);
   }

   function getBusinessDates(startDate, endDate) {
      let currentDate = new Date(startDate);
      currentDate.setHours(0, 0, 0, 0);
      let newAvailableDays = [];

      while (currentDate <= endDate) {
         let dayOfTheWeek = currentDate.getDay();
         if (dayOfTheWeek !== 0 && dayOfTheWeek !== 6) {
            newAvailableDays.push(new Date(currentDate));
         }
         currentDate.setDate(currentDate.getDate() + 1);
      }
      return newAvailableDays;
   }

   async function createAppointments(reqData) {
      await api.post("/api/createOOAppointment", reqData, header)
         .then((data) => {
            console.log(data);
            setSelectedTimeSlot(false);
            setProgress("success");
            window.scrollTo(0, 0);

         })
         .catch((err) => {
            console.log(JSON.stringify(err.response.data, null, 1));
            /* setErrorMessage({
                     error: "onOffice",
                     message: JSON.stringify(err.response.data, null, 1),
                  }); */
         });
   }

   async function getFototermine() {
      let timeLimit = [];

      timeLimit = parseOODate(terminData.datum_von, terminData.datum_bis);
      let newAvailableDays = getBusinessDates(terminData.datum_von, terminData.datum_bis);
      setAvailableDays(newAvailableDays);

      let parameters = {
         data: [
            "id",
            "type",
            "subject",
            "notes",
            "status",
            "date",
            "location",
            "users",
            "contacts",
            "estate",
            "travelTime",
         ],
         filter: {
            startDate: timeLimit[0],
            endDate: timeLimit[1],
            isCancelled: false,
            userIds: [terminData.fotograf], //Dsauter, Haase
         },
      };

      let [terminResponse, fullDataTermin, newAvailableUsers] = await getAppointmentsWithLocations(parameters);
      console.log(terminResponse);

      let orderedTermine = newAvailableDays.reduce((oldObj, item) => ({ ...oldObj, [item.toDateString()]: [] }), {});

      console.log(orderedTermine);

      terminResponse.forEach((item) => {
         let dateKey = new Date(item.elements.date.start).toDateString();
         if (orderedTermine[dateKey]) {
            // dauertermine werden so rausgefiltert
            orderedTermine[dateKey] = [...orderedTermine[dateKey], item.elements];
         }
      });
      /* .reduce((oldObj, item) => {
            let dateKey = new Date(item.elements.date.start).toDateString();
            return { ...oldObj, [dateKey]: oldObj[dateKey] ? [...oldObj[dateKey], item.elements] : [item.elements] };
         }, {}); */

      // console.log(availableDays);

      console.log(orderedTermine);

      let freeTimeSlots = {};
      let fullDataTerminObjects = fullDataTermin.reduce((oldObj, item) => ({ ...oldObj, [item.terminId]: item }), {});
      console.log(fullDataTerminObjects);

      Object.keys(orderedTermine).forEach((dayIte) => {
         freeTimeSlots = { ...freeTimeSlots, [dayIte]: [] };
         let dailyStartTime;
         let dailyEndTime;
         let startLuecke;
         let endLuecke;

         let kernArbeitszeitTermine = structuredClone(orderedTermine[dayIte]);

         if (!kernArbeitszeitTermine.length) {
            let morning = new Date(Date.parse(dayIte));

            let evening = new Date(Date.parse(dayIte));

            morning.setHours(...startHour, 0, 0);
            evening.setHours(...endHour, 0, 0);
            // console.log(today);

            kernArbeitszeitTermine = [
               { date: { start: morning, end: evening, id: 0 } },
               { date: { start: morning, end: evening, id: 0 } },
            ];

            console.log(kernArbeitszeitTermine);
            let distanceBefore =
               pufferZeit +
               10 +
               Math.ceil(
                  0.2 *
                     turf.distance(
                        turf.point([parseFloat(objData.laengengrad), parseFloat(objData.breitengrad)]),
                        turf.point(zustandigkeit[area].location),
                        {
                           units: "kilometers",
                        },
                     ),
               ) *
                  5;

            freeTimeSlots[dayIte].push({
               id: morning.getTime(),
               terminOrtAfter: zustandigkeit[area].location,
               distanceAfter: distanceBefore,
               terminOrtBefore: zustandigkeit[area].location,
               distanceBefore: distanceBefore,
               deltatime: Math.ceil(((evening - morning) / 60000) * 0.2) * 5,
               start: morning,
               end: evening,
            });
         }

         dailyStartTime = new Date(kernArbeitszeitTermine[0].date.start);
         dailyStartTime.setHours(...startHour, 0, 0);

         console.log(kernArbeitszeitTermine);

         dailyEndTime = new Date(kernArbeitszeitTermine[0].date.start);
         dailyEndTime.setHours(...endHour, 0, 0);

         if (new Date(kernArbeitszeitTermine[0].date.start) > dailyStartTime) {
            kernArbeitszeitTermine.unshift({ date: { end: dailyStartTime, id: 0 } });
         }

         if (new Date(kernArbeitszeitTermine[kernArbeitszeitTermine.length - 1].date.end) < dailyEndTime) {
            kernArbeitszeitTermine.push({ date: { start: dailyEndTime, id: 0 } });
         }

         kernArbeitszeitTermine.forEach((terminIte, index) => {
            if (index > 0 /* && index < kernArbeitszeitTermine.length */) {
               startLuecke = new Date(kernArbeitszeitTermine[index - 1].date.end);
               endLuecke = new Date(terminIte.date.start);

               let deltaTime;

               deltaTime = (endLuecke - startLuecke) / 60000;

               let newTerminOrtPoint = turf.point([parseFloat(objData.laengengrad), parseFloat(objData.breitengrad)]);

               let terminOrtAfter;
               if (fullDataTerminObjects[terminIte.id]) {
                  terminOrtAfter = [
                     parseFloat(fullDataTerminObjects[terminIte.id].laengengrad),
                     parseFloat(fullDataTerminObjects[terminIte.id].breitengrad),
                  ];
               } else {
                  terminOrtAfter = zustandigkeit[area].location;
               }

               let distanceAfter =
                  pufferZeit +
                  10 +
                  Math.ceil(
                     0.2 *
                        turf.distance(newTerminOrtPoint, turf.point(terminOrtAfter), {
                           units: "kilometers",
                        }),
                  ) *
                     5;

               let terminOrtBefore;
               if (kernArbeitszeitTermine[index - 1] && fullDataTerminObjects[kernArbeitszeitTermine[index - 1].id]) {
                  terminOrtBefore = [
                     parseFloat(fullDataTerminObjects[kernArbeitszeitTermine[index - 1].id].laengengrad),
                     parseFloat(fullDataTerminObjects[kernArbeitszeitTermine[index - 1].id].breitengrad),
                  ];
               } else {
                  terminOrtBefore = zustandigkeit[area].location;
               }

               let distanceBefore =
                  pufferZeit +
                  10 +
                  Math.ceil(
                     0.2 *
                        turf.distance(newTerminOrtPoint, turf.point(terminOrtBefore), {
                           units: "kilometers",
                        }),
                  ) *
                     5;

               deltaTime -= distanceBefore * 1;
               deltaTime -= distanceAfter * 1;

               deltaTime -= 2 * 15; //start und endpuffer

               if (/* true || */ deltaTime > terminData.duration) {
                  freeTimeSlots[dayIte].push({
                     id: startLuecke.getTime(),
                     terminOrtAfter: terminOrtAfter,
                     distanceAfter: distanceAfter,
                     terminOrtBefore: terminOrtBefore,
                     distanceBefore: distanceBefore,
                     deltatime: Math.ceil(deltaTime * 0.2) * 5,
                     start: startLuecke,
                     end: endLuecke,
                  });
               }
            }
         });
      });
      setTimeSlots(freeTimeSlots);
      console.log(freeTimeSlots);

      setBasicDataTermine(orderedTermine);
      setAvailableUsers(newAvailableUsers);
      console.log(fullDataTermin);

      let newTerminOrtPoint = turf.point([parseFloat(objData.laengengrad), parseFloat(objData.breitengrad)]);

      let newFullData = fullDataTermin
         .filter((item) => item.benutzer.some((userItem) => userItem.id === zustandigkeit[area].id))
         .map((terminIte) => {
            let terminOrt = turf.point([parseFloat(terminIte.laengengrad), parseFloat(terminIte.breitengrad)]);
            var distance = turf.distance(newTerminOrtPoint, terminOrt, { units: "kilometers" });
            return { ...terminIte, distanceToNewTermin: distance };
         });

      setTerminObjects(newFullData.reduce((oldObj, item) => ({ ...oldObj, [item.terminId]: item }), {}));
      // let proximityTermine=newFullData.filter(item=>item.distanceToNewTermin<10)
      console.log(newFullData);

      setFullDataTermine(newFullData);
   }

   return (
      <>
         <title>{`FT ${""}`}</title>
         <div className="m-5 mt-4" style={{ position: "relative" }}>
            <h1>Fototermin buchen</h1>
            {progress === "success" && (
               <Alert variant="success">
                  <AlertHeading>Termin wurde eingetragen!</AlertHeading>
               </Alert>
            )}
            <Form style={{ position: "relative", zIndex: 1000 }}>
               <Row>
                  <Form.Group as={Col} className="mb-3" controlId="anzahl_zimmer">
                     <Form.Label>Zimmeranzahl</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="anzahl_zimmer"
                        value={terminData.anzahl_zimmer}
                     />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3" controlId="ordnungszustand">
                     <Form.Label>Ordnungszustand</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="ordnungszustand"
                        value={terminData.ordnungszustand}
                     >
                        <option value=""></option>
                        <option value="Leer stehend/sehr aufgeräumt">Leer stehend/sehr aufgeräumt</option>
                        <option value="Normal (es muss ein wenig aufgeräumt werden)">
                           Normal (es muss ein wenig aufgeräumt werden)
                        </option>
                        <option value="Sehr viel zum Aufräumen">Sehr viel zum Aufräumen</option>
                     </Form.Select>
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3" controlId="wohnflaeche">
                     <Form.Label>Wohnfläche [m²]</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="wohnflaeche"
                        value={terminData.wohnflaeche}
                     />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3" controlId="objektart">
                     <Form.Label>Objektart</Form.Label>
                     <Form.Control
                        disabled
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="objektart"
                        value={terminData.objektart}
                     />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3" controlId="grundstuecksflaeche">
                     <Form.Label>ggf. Grundstücksfläche [m²]</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="grundstuecksflaeche"
                        value={terminData.grundstuecksflaeche}
                     />
                  </Form.Group>
               </Row>
               <Row>
                  <Form.Group as={Col} className="mb-3" controlId="fotos">
                     <Form.Label>Fotos</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="fotos"
                        value={terminData.fotos}
                     >
                        <option value=""></option>
                        <option value="Ja">Ja</option>
                        <option value="Nein">Nein</option>
                     </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3" controlId="luftaufnahmen">
                     <Form.Label>Luftaufnahmen</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="luftaufnahmen"
                        value={terminData.luftaufnahmen}
                     >
                        <option value=""></option>
                        <option value="Ja">Ja</option>
                        <option value="Nein">Nein</option>
                     </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3" controlId="ogulo">
                     <Form.Label>Ogulo</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="ogulo"
                        value={terminData.ogulo}
                     >
                        <option value=""></option>
                        <option value="Ja">Ja</option>
                        <option value="Nein">Nein</option>
                     </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3" controlId="matterport">
                     <Form.Label>Matterport</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="matterport"
                        value={terminData.matterport}
                     >
                        <option value=""></option>
                        <option value="Ja">Ja</option>
                        <option value="Nein">Nein</option>
                     </Form.Select>
                  </Form.Group>
               </Row>
               <Row>
                  <Form.Group as={Col} controlId={"datum_von"} className="mb-3">
                     <Form.Label>Wunschdatum von</Form.Label>
                     <DatePicker
                        isClearable
                        selected={terminData.datum_von}
                        onChange={(e) => changeTerminData("datum_von", e)}
                        className={"bootstrap-datepicker"}
                        calendarClassName="custom-date-calendar"
                        dateFormat="dd.MM.yyyy"
                        popperPlacement="bottom"
                        locale="de"
                     />
                  </Form.Group>
                  <Form.Group as={Col} controlId={"datum_bis"} className="mb-3">
                     <Form.Label>bis</Form.Label>
                     <DatePicker
                        isClearable
                        selected={terminData.datum_bis}
                        onChange={(e) => changeTerminData("datum_bis", e)}
                        className={"bootstrap-datepicker"}
                        calendarClassName="custom-date-calendar"
                        dateFormat="dd.MM.yyyy"
                        popperPlacement="bottom"
                        locale="de"
                     />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3" controlId="matterport">
                     <Form.Label>Fotograf</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="fotograf"
                        value={terminData.fotograf}
                     >
                        <option value=""></option>
                        {userObjects &&
                           Object.values(userObjects)
                              .sort((a, b) => (a.Nachname > b.Nachname ? 1 : -1))
                              .map((userObj) => {
                                 return (
                                    <option value={userObj.id}>
                                       {userObj.Nachname} {userObj.Vorname}
                                    </option>
                                 );
                              })}
                     </Form.Select>
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3" controlId="matterport">
                     <Form.Label>Makler</Form.Label>
                     <Form.Select
                        autoComplete="off"
                        placeholder=""
                        onChange={(e) => changeTerminData(e.target.name, e.target.value)}
                        name="benutzer"
                        value={terminData.benutzer}
                     >
                        <option value=""></option>
                        {userObjects &&
                           Object.values(userObjects)
                              .sort((a, b) => (a.Nachname > b.Nachname ? 1 : -1))
                              .map((userObj) => {
                                 return (
                                    <option value={userObj.id}>
                                       {userObj.Nachname} {userObj.Vorname}
                                    </option>
                                 );
                              })}
                     </Form.Select>
                  </Form.Group>
               </Row>
            </Form>
            <hr />
            <div className="d-flex justify-content-end mt-1">
               <span>
                  Zuständigkeitsbereich: <strong>{area}</strong>{" "}
               </span>{" "}
               <span className="mx-3">
                  Termindauer: <strong>{terminData.duration}</strong> Minuten{" "}
               </span>{" "}
               <Button
                  disabled={!(terminData.datum_bis && terminData.datum_von && terminData.duration)}
                  onClick={() => {
                     getFototermine();
                  }}
               >
                  Termin suchen
               </Button>
            </div>
            <div className="flex-row mt-3" style={{ alignItems: "start" }}>
               <div className=" flex-col w-50 pe-3">
                  <div className="calender-frame">
                     <div className="calender-column">
                        {calenderInterval.map((hourItem) => (
                           <div className="time-row"> {hourItem}</div>
                        ))}
                     </div>

                     {availableDays.map((dayIte) => {
                        let dateKey = dayIte.toDateString();
                        return (
                           <div className="calender-column">
                              <div className="user-row" style={{ zIndex: 1 }}>
                                 {dayIte.toLocaleString("de-DE", { weekday: "short" }) +
                                    " " +
                                    dayIte.toLocaleDateString().slice(0, 5)}
                              </div>
                              {weatherData &&
                                 weatherData[dateKey] &&
                                 weatherData[dateKey].map((weatherIte) => {
                                    let startTime = new Date(weatherIte.dt * 1000);

                                    let myHeight = 180;

                                    let myTop = startTime.getHours() * 60 + startTime.getMinutes() - 7 * 60;

                                    const myStyle = {
                                       height: myHeight,
                                       top: myTop,
                                       // backgroundSize: "20px 20px",
                                       // background: weatherColors[weatherIte.weather[0].main],
                                       // backgroundColor: weatherColors[weatherIte.weather[0].main],
                                       backgroundImage: `url(https://openweathermap.org/img/wn/${weatherIte.weather[0].icon}@2x.png)`,
                                    };
                                    return (
                                       <div
                                          title={weatherIte.weather && weatherIte.weather[0].description}
                                          className="appointment-row calender-weather"
                                          style={myStyle}
                                       ></div>
                                    );
                                 })}
                              {timeSlots &&
                                 timeSlots[dateKey] &&
                                 timeSlots[dateKey].map((timeSlotIte) => {
                                    const startTime = new Date(timeSlotIte.start);
                                    const endTime = new Date(timeSlotIte.end);
                                    let myHeight = (endTime - startTime) / 60000;

                                    let myTop = startTime.getHours() * 60 + startTime.getMinutes() - 7 * 60;

                                    const myStyle = {
                                       height: myHeight,
                                       top: myTop,
                                       backgroundColor: "#090a",
                                       transform:
                                          selectedTimeSlot && selectedTimeSlot.id === timeSlotIte.id
                                             ? "scale(1.05)"
                                             : "",
                                       boxShadow:
                                          selectedTimeSlot && selectedTimeSlot.id === timeSlotIte.id
                                             ? "5px 5px 20px #242"
                                             : "",
                                       borderTop: `solid ${timeSlotIte.distanceBefore}px #fff6`,
                                       borderBottom: `solid ${timeSlotIte.distanceAfter}px #fff6`,
                                       zIndex: selectedTimeSlot && selectedTimeSlot.id === timeSlotIte.id ? 1000 : 0,
                                    };
                                    return (
                                       <div
                                          onClick={() => {
                                             console.log(timeSlotIte);
                                             getRoute(timeSlotIte);
                                             // setSelectedTermin(timeSlotIte.id);
                                          }}
                                          title={" | "}
                                          className="appointment-row"
                                          style={myStyle}
                                       >
                                          {"Weg: " +
                                             Math.round(timeSlotIte.distanceAfter + timeSlotIte.distanceBefore) +
                                             " km"}
                                          {/*  {terminObjects[timeSlotIte.id] && (
                                             <small className="ms-1">
                                                ({Math.round(terminObjects[timeSlotIte.id].distanceToNewTermin)}km)
                                             </small>
                                          )} */}
                                       </div>
                                    );
                                 })}
                              {basicDataTermine &&
                                 basicDataTermine[dateKey] &&
                                 basicDataTermine[dateKey]
                                    /* .filter((item) =>
                                       item.users.some((userItem) => userItem.id === zustandigkeit[area].id)
                                    ) */
                                    .map((terminItem) => {
                                       const startTime = new Date(terminItem.date.start);
                                       const endTime = new Date(terminItem.date.end);
                                       let myHeight = (endTime - startTime) / 60000;

                                       let myTop = startTime.getHours() * 60 + startTime.getMinutes() - 7 * 60;
                                       if (terminItem.travelTime) {
                                          myTop -= terminItem.travelTime.outward;
                                          myHeight += terminItem.travelTime.outward + terminItem.travelTime.return;
                                       }

                                       /* console.log(
                                          terminObjects &&
                                             terminObjects[terminItem.id] &&
                                             Math.min(1, 10 / terminObjects[terminItem.id].distanceToNewTermin)
                                       ); */

                                       //`rgba(0,190,0,${Math.min(1, 10 / terminObjects[terminItem.id].distanceToNewTermin)})`

                                       const myStyle = {
                                          height: myHeight,
                                          top: myTop,
                                          backgroundColor:
                                             terminObjects && terminObjects[terminItem.id] ? `#224c` : "#a00c",
                                          outline:
                                             selectedTermin === terminItem.id ? "dashed 4px #224" : "solid 1px #ddd",
                                          borderTop: terminItem.travelTime
                                             ? `solid ${terminItem.travelTime.outward}px #fff6`
                                             : "",
                                          borderBottom: terminItem.travelTime
                                             ? `solid ${terminItem.travelTime.return}px #fff6`
                                             : "",
                                       };

                                       if (terminItem.notes && terminItem.notes.includes("flexibel")) {
                                          myStyle.backgroundColor = "#626";
                                       }

                                       return (
                                          <div
                                             onClick={() => {
                                                console.log(terminItem);
                                                setSelectedTermin(terminItem.id);
                                             }}
                                             title={terminItem.type.label + " | " + terminItem.subject}
                                             className="appointment-row"
                                             style={myStyle}
                                          >
                                             <span>
                                                {" "}
                                                {terminItem.type.label && terminItem.type.label.includes("Fototermin")
                                                   ? "FT"
                                                   : terminItem.type.label}
                                             </span>
                                             {terminObjects[terminItem.id] && (
                                                <small className="ms-1">
                                                   ({Math.round(terminObjects[terminItem.id].distanceToNewTermin)}km)
                                                </small>
                                             )}
                                          </div>
                                       );
                                    })}
                           </div>
                        );
                     })}
                  </div>
                  <FototerminErstellung
                     createAppointments={createAppointments}
                     selectedTimeSlot={selectedTimeSlot}
                     setSelectedTimeSlot={setSelectedTimeSlot}
                     terminData={terminData}
                     setTerminData={setTerminData}
                     objData={objData}
                     ownerId={ownerId}
                  />
               </div>
               <div className=" flex-col ps-3" style={{ height: "660px", width: "50%" }}>
                  <Karte
                     centerPin={objData}
                     suedPolygon={suedPolygon}
                     terminInfos={fullDataTermine}
                     availableUsers={availableUsers}
                     userObjects={userObjects}
                     showAllUsers={true}
                     showAlleTage={true}
                     setSelectedTermin={setSelectedTermin}
                     selectedTermin={selectedTermin}
                     /*calenderday={calenderday}
                                 terminArten={terminArten} */
                  />
               </div>
            </div>
         </div>
      </>
   );
}
